var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReservationCalendar',{on:{"dateSelected:date":function($event){return _vm.selectDate($event)}}}),_c('DayOverview',{attrs:{"selected-date":_vm.selectedDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }